import React from 'react';
import { Map } from './components/map';
import { Header } from './components/header';

const App = () => {
  return (
    <div>
      <Header />
      <Map />
    </div>
  );
};

export default App;
